import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-custom-snackbar',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatIconModule],
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss']
})

export class CustomSnackbarComponent implements OnInit, OnDestroy {
    private autoCloseTimer: any;
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: any,
        public snackBarRef: MatSnackBarRef<CustomSnackbarComponent>,
        private router: Router
    ) {}
    
    ngOnInit() {
      // Auto close setelah 1 menit (60000 ms)
      this.autoCloseTimer = setTimeout(() => {
        if (this.snackBarRef) {
          this.snackBarRef.dismiss();
          console.log("Snackbar auto closed after 2 minutes");
        }
      }, 60000);
    }
  
    ngOnDestroy() {
      // Bersihkan timer kalau snackbar ditutup manual
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
      }
    }
  
    onAction(action: string, url?: string, key?: string) {
      console.log("action: ", action);
      if (action === 'open') {
        this.router.navigate([url, key]);
      }else if (action === 'news') {
        this.router.navigate([url]);
      }else if (action === 'close') {
        this.snackBarRef.dismiss();
      } else {
        window.open(url, '_blank');
      }
      this.snackBarRef.dismiss();
    }
}